import instance from "../../../config/axios";
import url from "../../../constants/url";

const gcblendsheet = "gcblendsheet";
const mrin = "mrin";
const view = "view";
const blendsheet = "blendsheet";
const batchnumber = "batchnumber";
const workorderInfo = "workorder-info";
const grid = "grid";
const viewpicklist = "view-pick-list";
const gridstatuslist = "grid-status-list";
const entitylist = "entity-list";
const dispatchlist = "dispatch-list";
const dispatchdetails = "dispatch-details";
const alternativeSampleInfo = "alternative-sample-info";
const update = "update";
const productionSampleList = 'production-sample-list';
const updateStatus = 'update-status';
const gcItem = 'gcitem';
const coffeeType = 'gc-coffee-type';
const totalProductionQuantity = "total-production-quantity";
const productionScheduleTotalProductionQuantity = "production-schedule-total-production-quantity";
const getMRINInventoryDetails = "mrin-list";
const createUpdateBlendsheetInventory = "create-update-blendsheet-inventory";
const checkNetsuiteInventoryAvailable = "check-netsuite-inventory-available";
const deleteInventoryDetails = "delete-inventory-details";
const syncBlendsheetToNetsuite = "sync-blendsheet-to-netsuite";
const alternativeSampleList = "alternative-sample-list";
const productionScheduleList = "production-schedule-list";
const productionScheduleDetails = "production-schedule-details";
const create = "create";
const mrinBlendsheetUsage = "mrin-blendsheet-usage";
const blendsheetInventoryDetails = "blendsheet-inventory-details";
const mrinSubLocations = "mrin-sub-locations";

// get Quoted alternative sample list
export const getAlternativeSampleInfo = (payload) => {
  return instance
    .post(`${url.packagingapiurl}${gcblendsheet}/${alternativeSampleInfo}`, payload)
    .then((res) => {
      return res;
    });
};

// get production alternative sample list
/** @param {{ alternative_sample_id: string; product_category: string; entity_name: string; limit: number; search: string | null }} payload
 * @returns {Promise<import("./types").AlternativeSampleListItem[]>} */
export const getProdAlternativeSampleInfo = (payload) => {
  return instance
    .post(`${url.packagingapiurl}${gcblendsheet}/${productionSampleList}`, payload)
    .then((res) => {
      return res;
    });
};

// get dispatch list
export const getDispatchList = (payload) => {
  return instance
    .post(`${url.packagingapiurl}${gcblendsheet}/${dispatchlist}`, payload)
    .then((res) => {
      return res;
    });
};

// get dispatch details
export const getDispatchDetails = (id) => {
  return instance
    .get(`${url.packagingapiurl}${gcblendsheet}/${dispatchdetails}/${encodeURIComponent(id)}`)
    .then((res) => {
      return res;
    });
};

// get blendsheet list
export const getBlendSheetList = async (payload) => {
  const res = await instance.post(
    `${url.packagingapiurl}${gcblendsheet}/${grid}`, payload
  );
  return res;
};

// get view pick list
export const getBlendsheetViwPickList = () => {
  return instance
    .get(`${url.packagingapiurl}${gcblendsheet}/${gridstatuslist}`)
    .then((res) => {
      return res;
    });
};

// get entity list
/** @returns {Promise<{ entity_name: string; entity_id: string | number }[]>} */
export const getEntityList = () => {
  return instance
    .get(`${url.packagingapiurl}${gcblendsheet}/${entitylist}`)
    .then((res) => {
      return res;
    });
};

// get status list
export const getBlendsheetStatusList = () => {
  return instance
    .get(`${url.packagingapiurl}${gcblendsheet}/${viewpicklist}`)
    .then((res) => {
      return res;
    });
};

//Get Coffee Type
/** @param {string|number} id
 * @returns {Promise<{ coffee_type: string }>} */
export const getCoffeeType = (id) => {
  return instance
    .get(`${url.packagingapiurl}${gcItem}/${coffeeType}/${id}`)
    .then((res) => {
      return res;
    });
};

// update blendsheet data
/** @param {import("./types").BlendSheetSubmitPayload} data
 * @returns {Promise<{ batchNumber?: string } | null>} */
export const updateBlendSheet = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${gcblendsheet}/${update}`,
    data
  );
  return res;
};

// update blendsheet status
/** @returns {Promise<object | null>} */
export const updateBlendSheetStatus = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${gcblendsheet}/${updateStatus}`,
    data
  );
  return res;
};

// Checking the Total Production Quantity
/** @param {string} id
 * @returns {Promise<number>} */
export const checkTotalProductionQuantity = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${gcblendsheet}/${totalProductionQuantity}/${encodeURIComponent(id)}`
  );
  return res;
};

// Checking the Total Production Quantity for a single Production Schedule record
/** @param {string} id
 * @returns {Promise<number>} */
export const checkPSTotalProductionQuantity = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${gcblendsheet}/${productionScheduleTotalProductionQuantity}/${encodeURIComponent(id)}`
  );
  return res;
};

// Get MRIN Inventory Details
/** @param {{ item_id?: string | number; item_code?: string; entity_name?: string; search: string }} payload
 * @returns {Promise<import("./types").MrinInventoryAllocationRow[]>} */
export const getMRINInventoryList = async (payload) => {
  const res = await instance.post(
    `${url.packagingapiurl}${gcblendsheet}/${getMRINInventoryDetails}`, payload
  );
  return res;
};

// Create/Update BlendSheet Inventory
/** @returns {Promise<object | null>} */
export const createUpdateBSInventory = async (payload) => {
  const res = await instance.post(
    `${url.packagingapiurl}${gcblendsheet}/${createUpdateBlendsheetInventory}`, payload
  );
  return res;
};

// Check Netsuite Inventory Available
/** @param {import("./types").NetsuiteInventoryCheckItem[]} payload
 * @returns {Promise<{ mrin_no?: string; error_message?: string; status?: boolean }[] | undefined>} */
export const onCheckNetsuiteInventoryAvailable = async (payload) => {
  const res = await instance.post(
    `${url.packagingapiurl}${gcblendsheet}/${checkNetsuiteInventoryAvailable}`, payload
  );
  return res;
};

// Delete MRIN Inventory
/** @returns {Promise<object | null>} */
export const deleteMRINInventory = async (payload) => {
  const res = await instance.post(
    `${url.packagingapiurl}${gcblendsheet}/${deleteInventoryDetails}`, payload
  );
  return res;
};

// Approve Netsuite BlendSheet
/** @param {string} id
 * @returns {Promise<{ reason?: string; netSuiteId?: string }>} */
export const approvenetsuiteBlendSheet = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${gcblendsheet}/${syncBlendsheetToNetsuite}/${encodeURIComponent(id)}`
  );
  return res;
};

// Get Alternative Sample List
/** @param {{ entity_name: string; limit: number; search: string | null }} payload
 * @returns {Promise<import("./types").AlternativeSampleListItem[]>} */
export const getAlternativeSampleList = async (payload) => {
  const res = await instance.post(
    `${url.packagingapiurl}${gcblendsheet}/${alternativeSampleList}`, payload
  );
  return res;
};

// Get Production Schedule List
/** @param {{ alternative_sample_id: string | number; entity_name: string; limit: number; search: string | null }} payload
 * @returns {Promise<import("./types").ProductionScheduleOption[]>} */
export const getProductionScheduleList = async (payload) => {
  const res = await instance.post(
    `${url.packagingapiurl}${gcblendsheet}/${productionScheduleList}`, payload
  );
  return res;
};

// Get Production Schedule Details
/** @param {number} id
 * @returns {Promise<import("./types").ProductionScheduleDetailsResponse | null>} */
export const getProductionScheduleDetails = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${gcblendsheet}/${productionScheduleDetails}/${encodeURIComponent(id)}`
  );
  return res;
};

// Create BlendSheet
export const createBlendSheet = async (payload) => {
  const res = await instance.post(
    `${url.packagingapiurl}${gcblendsheet}/${create}`, payload
  );
  return res;
};

// MRIN BlendSheet Usage
/**
 * @param {string|number} id
 * @returns {Promise<import("./types").MrinBlendsheetUsageRow[]>}
 */
export const getMrinBlendsheetUsage = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${gcblendsheet}/${mrinBlendsheetUsage}/${encodeURIComponent(id)}`
  );
  return res;
};

// Get Batch Number
/** @param {string} company
 * @returns {Promise<{ financialyear: string; batchnumber: number } | null>} */
export const getBatchNumber = async (company) => {
  const res = await instance.get(
    `${url.packagingapiurl}${mrin}/${blendsheet}/${batchnumber}/${company}`
  );
  return res;
};

// Get BlendSheet Details
/** @param {string} id
 * @returns {Promise<import("./types").BlendSheetDetailsApiResponse>} */
export const getBlendSheetDetails = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${gcblendsheet}/${view}/${id}`
  );
  return res;
};

// Delete Blend Sample Details
/** @param {string} id
 * @returns {Promise<{ batchNumber?: string }>} */
export const deleteBlendSampleDetails = async (id) => {
  const res = await instance.delete(
    `${url.sampleManagementApiUrl}${blendsheet}/${id}`
  );
  return res;
};

// Get Work Order Info
/** @param {string|number} blendsheet_id
 * @returns {Promise<import("./types").WorkOrderInfoResponse>} */
export const getWorkOrderInfo = (blendsheet_id) => {
  return instance
    .get(`${url.packagingapiurl}${gcblendsheet}/${workorderInfo}/${blendsheet_id}`)
    .then((res) => {
      return res;
    });
};

// Get Blendsheet Inventory Details
/** @param {string|number} item_id
 * @param {string|number} blendsheet_id
 * @returns {Promise<import("./types").MrinInventoryAllocationRow[]>} */
export const getBlendsheetInventoryDetails = (item_id, blendsheet_id) => {
  return instance
    .get(`${url.packagingapiurl}${gcblendsheet}/${blendsheetInventoryDetails}/${encodeURIComponent(item_id)}/${encodeURIComponent(blendsheet_id)}`)
    .then((res) => {
      return res;
    });
};

// Get MRIN Sub Locations
/** @param {{ item_id?: string | number; item_code?: string; entity_name?: string }} payload
 * @returns {Promise<import("./types").MrinInventoryAllocationRow[]>} */
export const getMRINSubLocation = (payload) => {
  return instance
    .post(`${url.packagingapiurl}${gcblendsheet}/${mrinSubLocations}`, payload)
    .then((res) => {
      return res;
    });
};

